import { Grid } from '@material-ui/core';
import { PaymentMethodType } from '@nemuru-eng/checkout-js';
import { A2APayment, CardPayment } from '@nemuru-eng/js-api-client';

import { SinglePaymentConditionsSummary } from '@/components/modules/SinglePayment/_shared/components/SinglePaymentConditionsSummary';
import { SinglePaymentProvider } from '@/components/modules/SinglePayment/_shared/components/SinglePaymentProvider';

interface SinglePaymentDetailsProps {
  singlePayment: CardPayment | A2APayment;
  paymentMethodType: PaymentMethodType.A2A_PAYMENT | PaymentMethodType.CARD_PAYMENT;
}
export const SinglePaymentDetails = ({ singlePayment, paymentMethodType }: SinglePaymentDetailsProps) => {
  return (
    <Grid container spacing={8} alignItems={'flex-start'}>
      <Grid item xs={12} md={6}>
        <SinglePaymentConditionsSummary singlePayment={singlePayment} paymentMethodType={paymentMethodType} />
      </Grid>
      <Grid item xs={12} md={6}>
        <SinglePaymentProvider singlePayment={singlePayment} />
      </Grid>
    </Grid>
  );
};
